/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_New_Need_PeopleInputs */

const cs_chat_new_need_people = /** @type {(inputs: Chat_New_Need_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte alespoň jednoho člověka.`)
};

const en_chat_new_need_people = /** @type {(inputs: Chat_New_Need_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select at least one person.`)
};

/**
* | output |
* | --- |
* | "Select at least one person." |
*
* @param {Chat_New_Need_PeopleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_new_need_people = /** @type {((inputs?: Chat_New_Need_PeopleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_New_Need_PeopleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_new_need_people(inputs)
	return cs_chat_new_need_people(inputs)
});